import { Navigate, Outlet } from 'react-router';

import { useMe } from '@/platform/auth/use-me';
import { MasterDataNav } from '@/platform/features/master-data/master-data-nav';
import { masterDataHomePath } from '@/platform/lib/master-data-paths';

export function MasterDataIndexRedirect() {
  const me = useMe();
  if (!me.data) {
    return null;
  }
  return <Navigate to={masterDataHomePath(me.data)} replace />;
}

export function MasterDataLayoutPage() {
  return (
    <section className="w-full min-w-0 space-y-6">
      <MasterDataNav />
      <Outlet />
    </section>
  );
}
